import { tutor_profile } from './common-routes'
export const getLinkTeacherProfile = (config, username) => {
  if (process.env.NODE_ENV === 'production') {
    return `/${tutor_profile.path}/${username}`
  }
  return `${config.base_url_website}/${tutor_profile.path}/${username}`
}
